import { FooterComponent } from "./footer/footer.component";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { IonicModule } from "@ionic/angular";
import { EpubComponent } from "./epub/epub.component";
import { AgregarlibroComponent } from "./agregarlibro/agregarlibro.component";
import { AgregarLibroComponent } from "./agregar-libro/agregar-libro.component";

import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CommonModule, DatePipe } from "@angular/common";
import { PdfComponent } from "./pdf/pdf.component";
import "@teamhive/stencil-pdf-viewer/dist/pdfviewer";
import { JwPaginationComponent } from "src/app/components/jw-pagination/jw-pagination.component";
import { CrearActividadComponent } from "./crear-actividad/crear-actividad.component";
import { ActividadNoautocalComponent } from "./actividad-noautocal/actividad-noautocal.component";

import { PresentacionComponent } from "./presentacion/presentacion.component";
import { ProfesorComponent } from "./profesor/profesor.component";
import { EstudiantesComponent } from "./estudiantes/estudiantes.component";
import { EstadisticasComponent } from "./estadisticas/estadisticas.component";
import { CertificadosComponent } from "./certificados/certificados.component";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { CrearActividadActividadesComponent } from "./crear-actividad-actividades/crear-actividad-actividades.component";
import { CommentsForumsComponent } from "./comments-forums/comments-forums.component";
import { CreateForumsComponent } from "./create-forums/create-forums.component";
import { ListForumsComponent } from "./list-forums/list-forums.component";
import { CrearCursoComponent } from "./curso/crear-curso/crear-curso.component";
import { NgxQRCodeModule } from "ngx-qrcode2";
import { CreateActionsCalendarComponent } from "./create-actions-calendar/create-actions-calendar.component";
import { CrearPupiloTutorComponent } from "./crear-pupilo-tutor/crear-pupilo-tutor.component";
import { NgCalendarModule } from "ionic2-calendar";
import { SeleccionarFechaEntregaComponent } from "./crear-actividad-actividades/seleccionar-fecha-entrega/seleccionar-fecha-entrega.component";
import { CrearActividadActividadesCursoComponent } from "./estudiantes_curso/crear-actividad-actividades-curso/crear-actividad-actividades-curso.component";
import { PresentacionEstudianteComponent } from "./estudiantes_curso/presentacion-estudiante/presentacion-estudiante.component";
import { CrearCursoEstudianteComponent } from "./estudiantes_curso/crear-curso-estudiante/crear-curso-estudiante.component";
import { ProfesorEstudianteComponent } from "./estudiantes_curso/profesor-estudiante/profesor-estudiante.component";
import { EstudiantesCompComponent } from "./estudiantes_curso/estudiantes_comp/estudiantes-comp.component";
import { RealizarActividadFrameComponent } from "./realizar-actividad-frame/realizar-actividad-frame.component";
import { OpcionMultipleComponent } from "./realizar-actividad-frame/opcion-multiple/opcion-multiple.component";
import { FalsoVerdaderoComponent } from "./realizar-actividad-frame/falso-verdadero/falso-verdadero.component";
import { CompletaEspacioComponent } from "./realizar-actividad-frame/completa-espacio/completa-espacio.component";
import { OrdenarComponent } from "./realizar-actividad-frame/ordenar/ordenar.component";
import { MemoriaComponent } from "./realizar-actividad-frame/memoria/memoria.component";
import { SopaLetrasComponent } from "./realizar-actividad-frame/sopa-letras/sopa-letras.component";
import { ClaseExplicacionComponent } from "./realizar-actividad-frame/clase-explicacion/clase-explicacion.component";
import { PreguntaAbiertaComponent } from "./realizar-actividad-frame/pregunta-abierta/pregunta-abierta.component";

import { DragulaModule } from "ng2-dragula";
import { SeguidoresComponent } from "./seguidores/seguidores.component";
import { SiguiendoComponent } from "./siguiendo/siguiendo.component";
import { MoreComponent } from "./more/more.component";
import { UserComponent } from "./user/user.component";
import { NotiBellComponent } from "./noti-bell/noti-bell.component";
import { NotiFollowersComponent } from "./noti-followers/noti-followers.component";
import { ModenaComponent } from "./modena/modena.component";
import { IdiomaComponent } from "./idioma/idioma.component";
import { PerfilComponent } from "./perfil/perfil.component";
import { NotificacionesComponent } from "./notificaciones/notificaciones.component";
import { ContrasenaComponent } from "./contrasena/contrasena.component";
import { CalificaCursoComponent } from "./califica-curso/califica-curso.component";
import { EpubviewerComponent } from "./epubviewer/epubviewer.component";
import { ModificarActividadActividadesComponent } from "./modificar-actividad-actividades/modificar-actividad-actividades.component";
import { FinishActivityComponent } from "./realizar-actividad-frame/finish-activity/finish-activity.component";
import { PipesModule } from "../pipes/pipes.module";
import { ViewActividadesComponent } from "./view-actividades/view-actividades.component";
import { SharedModule } from "../shared/shared.module";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { HttpClient } from "@angular/common/http";
import { NgxChartsModule } from "@swimlane/ngx-charts";
import { CreateActionsModalComponent } from "./create-actions-calendar/create-actions-modal/create-actions-modal.component";
import { PdfViewerModule } from "ng2-pdf-viewer";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";
import { IonicSelectableComponent } from "ionic-selectable";
import { EstudianteDetailActivityComponent } from "./estudiantes_curso/estudiante-detail-activity/estudiante-detail-activity.component";
import { ModalLoadFilesComponent } from "./modal-load-files/modal-load-files.component";
import { NgApexchartsModule } from "ng-apexcharts";
import { SecuenciaComponent } from "./realizar-actividad-frame/secuencia/secuencia.component";
import { ReproductorAudioLibroComponent } from "./reproductor-audio-libro/reproductor-audio-libro.component";
import { LibreriaFiltroComponent } from "../libreria/libreria-filtro/libreria-filtro.component";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MenuCursoComponent } from "../cursos/menu-curso/menu-curso.component";
import { CreateActividadOpcionMultipleComponent } from "./crear-actividad/create-actividad-opcion-multiple/create-actividad-opcion-multiple.component";
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}

@NgModule({
  declarations: [
    MoreComponent,
    UserComponent,
    EpubComponent,
    PdfComponent,
    CreateActionsModalComponent,
    AgregarlibroComponent,
    AgregarLibroComponent,
    JwPaginationComponent,
    CrearActividadComponent,
    ModificarActividadActividadesComponent,
    CrearActividadActividadesComponent,
    CrearActividadActividadesCursoComponent,
    ActividadNoautocalComponent,
    PresentacionComponent,
    PresentacionEstudianteComponent,
    ProfesorComponent,
    ProfesorEstudianteComponent,
    EstudiantesComponent,
    EstudiantesCompComponent,
    EstadisticasComponent,
    CertificadosComponent,
    CommentsForumsComponent,
    CreateForumsComponent,
    ListForumsComponent,
    CrearCursoComponent,
    CrearCursoEstudianteComponent,
    CreateActionsCalendarComponent,
    CrearPupiloTutorComponent,
    SeleccionarFechaEntregaComponent,
    RealizarActividadFrameComponent,
    OpcionMultipleComponent,
    FalsoVerdaderoComponent,
    CompletaEspacioComponent,
    OrdenarComponent,
    MemoriaComponent,
    SopaLetrasComponent,
    ClaseExplicacionComponent,
    PreguntaAbiertaComponent,
    SeguidoresComponent,
    SiguiendoComponent,
    NotiBellComponent,
    NotiFollowersComponent,
    ModenaComponent,
    IdiomaComponent,
    PerfilComponent,
    NotificacionesComponent,
    ContrasenaComponent,
    EpubviewerComponent,
    FinishActivityComponent,
    ViewActividadesComponent,
    CalificaCursoComponent,
    EstudianteDetailActivityComponent,
    ModalLoadFilesComponent,
    SecuenciaComponent,
    FooterComponent,
    ReproductorAudioLibroComponent,
    LibreriaFiltroComponent,
    MenuCursoComponent,
    CreateActividadOpcionMultipleComponent
  ],
  imports: [
    PdfViewerModule,
    SharedModule,
    IonicModule,
    NgxChartsModule,
    NgApexchartsModule,
    FormsModule,
    CommonModule,
    ReactiveFormsModule,
    NgxQRCodeModule,
    NgCalendarModule,
    DragulaModule,
    PipesModule,
    IonicSelectableComponent,
    ReactiveFormsModule,
    MatPaginatorModule,
  ],
  exports: [
    MoreComponent,
    UserComponent,
    NotiBellComponent,
    NotiFollowersComponent,
    EpubComponent,
    PdfComponent,
    AgregarlibroComponent,
    AgregarLibroComponent,
    CrearActividadComponent,
    ModificarActividadActividadesComponent,
    CrearActividadActividadesComponent,
    CrearActividadActividadesCursoComponent,
    ActividadNoautocalComponent,
    PresentacionComponent,
    PresentacionEstudianteComponent,
    ProfesorComponent,
    ProfesorEstudianteComponent,
    EstudiantesComponent,
    EstudiantesCompComponent,
    EstadisticasComponent,
    CertificadosComponent,
    JwPaginationComponent,
    CommentsForumsComponent,
    CreateForumsComponent,
    ListForumsComponent,
    CrearCursoComponent,
    CrearCursoEstudianteComponent,
    CreateActionsCalendarComponent,
    CrearPupiloTutorComponent,
    CreateActionsModalComponent,
    SeleccionarFechaEntregaComponent,
    RealizarActividadFrameComponent,
    OpcionMultipleComponent,
    FalsoVerdaderoComponent,
    CompletaEspacioComponent,
    OrdenarComponent,
    MemoriaComponent,
    SopaLetrasComponent,
    ClaseExplicacionComponent,
    PreguntaAbiertaComponent,
    SeguidoresComponent,
    SiguiendoComponent,
    ModenaComponent,
    IdiomaComponent,
    PerfilComponent,
    NotificacionesComponent,
    ContrasenaComponent,
    EpubviewerComponent,
    ViewActividadesComponent,
    CalificaCursoComponent,
    EstudianteDetailActivityComponent,
    FooterComponent,
    ReproductorAudioLibroComponent,
    LibreriaFiltroComponent,
    MenuCursoComponent,
    CreateActividadOpcionMultipleComponent
  ],
  providers: [DatePipe],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ComponentsModule {}
